import api from "./api";
import { rfqPath } from "./apiPaths";
import type {
  RaiseRfqQueryPayload,
  RfqActionPayload,
  RfqInvitationId,
  RfqQueryCreated,
  VendorRfqDetail,
  VendorRfqListParams,
  VendorRfqListResponse,
} from "../pages/Rfq/types";

function withQuery(params?: VendorRfqListParams): string {
  const sp = new URLSearchParams();
  Object.entries(params ?? {}).forEach(([key, value]) => {
    if (value != null && value !== "") sp.set(key, String(value));
  });
  const qs = sp.toString();
  return qs ? `?${qs}` : "";
}

function invitationPath(id: RfqInvitationId, suffix = ""): string {
  return rfqPath(`/${encodeURIComponent(String(id))}${suffix}`);
}

export function listRfqInvitations(params?: VendorRfqListParams): Promise<VendorRfqListResponse> {
  return api.get(`${rfqPath("")}${withQuery(params)}`);
}

export function getRfqInvitation(id: RfqInvitationId): Promise<VendorRfqDetail> {
  return api.get(invitationPath(id));
}

export function actOnRfq(id: RfqInvitationId, payload: RfqActionPayload): Promise<VendorRfqDetail> {
  return api.post(invitationPath(id, "/action"), payload);
}

export function raiseRfqQuery(id: RfqInvitationId, payload: RaiseRfqQueryPayload): Promise<RfqQueryCreated> {
  return api.post(invitationPath(id, "/queries"), payload);
}
